import { getNebulaClient, nebulaClient, nebulaClient2 } from "../../lib/nebulaClient";
import { MediaService } from "./nebula.service";
import { ILoginInfo } from "../auth/login/loginSlice";

export interface EnFaceInfoDTO {
    uuid: string;
    EnFaceWidth: number;
    EnFaceHeight: number;
    EnFaceWidthSizeInMicrons: number;
    EnFaceHeightSizeInMicrons: number;
}

export interface AnalysisDTO {
    kind: string;
    date: string;
    user: string;
    data: any;
}

export interface MediaInfoDTO {
    uuid: string;
    createdOn: string;
    modifiedOn: string;
    endedOnOpt: string;
    isActive: boolean;
    label: string;
    metaOpt: any;
    schema: string;
    mimeType: string;
    mediaLocationUri: string;
    mediaStatus: string;
    ScanDateAndTime: string;
    ScanPattern: string;
    Laterality: string;
    Manufacturer: string;
    Device: string;
    FileName: string;
    ImageQuality: number;
    RasterAngleInDeg: number;
    FirstBscanStartXInMm: number;
    FirstBscanStartYInMm: number;
    LastBscanStartXInMm: number;
    LastBscanStartYInMm: number;
    BscanWidthDim: number;
    BscanHeightDim: number;
    NumSlices: number;
    BscanWidthSizeInMicrons: number;
    BscanHeightSizeInMicrons: number;
    NumSlicesSizeInMicrons: number;
    UniqueId: string;
    SiteId: string;
    SeriesId: number;
    Comment: string;
}

export interface UserDTO {
    userID: string;
    loginInfo: ILoginInfo;
    firstName: string;
    lastName: string;
    fullName: string;
    email: string;
    _activeOrgUuid: string;
    avatarURL: string;
    activated: boolean;
    adminFeatures: string;
    accessDate: string;
    accessExpires: string;
    accessOK: boolean;
    orgUuid: string;
    topOrgUuid: string;
    activeOrgUuid: string;
    _projectOrgUuid: string;
    consentUuid: string;
}

export const mediaService: MediaService = {
    getEnFaceInfo: async (mediaId: string) => {
        const response = await nebulaClient.get<EnFaceInfoDTO>(`/media/image/${mediaId}/ef.json/0`);

        return response;
    },
    getAnalysis: async (studyId: string) => {
        const response = await nebulaClient.get<AnalysisDTO[]>(`/study/analysis/${studyId}`);

        return response;
    },
    getMediaInfo: async (mediaId: string) => {
        const response = await nebulaClient.get<MediaInfoDTO>(`media/info/${mediaId}`);

        return response;
    },
    getSiteUsers: async (mediaId: string) => {
        const response = await nebulaClient.get<UserDTO[]>(`/user/reachable?level=media&key=${mediaId}`);

        return response;
    },
    getTextFile: async (url: string) => {
        const response = await getNebulaClient("", true).get<Blob>(url, {
            responseType: "blob",
        });

        return response;
    },
    getModalities: async (trialId) => {
        const response = await nebulaClient2.get<string[]>(`/trial/${trialId}/modality`);

        return response;
    },
    updateMediaModality: async (patientId, mediaId, modality) => {
        const response = await nebulaClient2.put<void>(`/patient/${patientId}/media/${mediaId}/modality`, {
            modality,
        });

        return response;
    },
    bulkUpdateMediaModalities: async (patientId, mediaModalitiesUpdates) => {
        const response = await nebulaClient2.put<void>(
            `/patient/${patientId}/media/modalities`,
            mediaModalitiesUpdates
        );

        return response;
    },
    bulkUpdateMediaLateralities: async (patientId, mediaLateralitiesUpdates) => {
        const response = await nebulaClient2.put<void>(`/patient/${patientId}/media/laterality`, {
            studiesToUpdate: mediaLateralitiesUpdates,
        });

        return response;
    },
};
